import {AfterContentInit, HostBinding} from '@angular/core';
import {Component} from '@angular/core';
import {ContentChild} from '@angular/core';
import {OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {UIInputDirective} from './input.directive';

@Component({
    selector: 'ui-input',
    templateUrl: 'input.component.html',
    styleUrls: ['input.component.scss']
})
export class UIInputComponent implements AfterContentInit, OnDestroy {

    private _onBlurSubscription: Subscription;

    private _onFocusSubscription: Subscription;

    @HostBinding('class.active')
    focused: boolean;

    @ContentChild(UIInputDirective)
    input: UIInputDirective;

    @HostBinding('class.dirty')
    get value(): string {
        return this.input.value;
    }

    ngAfterContentInit(): void {
        if (this.input) {
            this.input.onBlur.subscribe(() => {
                this.focused = false;
            });
            this.input.onFocus.subscribe(() => {
                this.focused = true;
            });
        }
    }

    ngOnDestroy(): void {
        this._destroyInput();
    }

    private _destroyInput(): void {
        if (this._onBlurSubscription) {
            this._onBlurSubscription.unsubscribe();
            this._onBlurSubscription = null;
        }
        if (this._onFocusSubscription) {
            this._onFocusSubscription.unsubscribe();
            this._onFocusSubscription = null;
        }
    }
}
